import React, { FC } from 'react'

export const Panel: FC = ({ children }) => {
  return <div className="panel">{children}</div>
}
